import {FETCH_SETTINGS, LIST_SETTINGS} from "./types";

const init = {
  isLoading: true,
  list: [],
  page: 1,
  totals: 0,
  size: 10
};

export default (state = init, {type, payload}) => {
  switch (type) {
    case FETCH_SETTINGS:
      return {
        ...state,
        isLoading: true
      };
    case LIST_SETTINGS:
      return {
        ...state,
        isLoading: false,
        list: payload.data,
        ...payload.paging
      };
    default:
      return state;
  }
}